<table *ngIf='showTable ; else errorTextField' mat-table [dataSource]="tableData" class="details-screen-table">
  <ng-container matColumnDef="level">
    <th mat-header-cell *matHeaderCellDef> Schijf </th>
    <td mat-cell *matCellDef="let data">{{data.level ? data.level : emptyValuePlaceholder}}</td>
  </ng-container>

  <ng-container matColumnDef="minimum">
    <th mat-header-cell *matHeaderCellDef> Ondergrens</th>
    <td mat-cell [ngClass]="{'red': data.minimum < 0}" *matCellDef="let data">{{getAmount(data.minimum, 'EUR')}}</td>
  </ng-container>

  <ng-container matColumnDef="interestPercentage">
    <th mat-header-cell *matHeaderCellDef> Nominaal % </th>
    <td mat-cell [ngClass]="{'red': data.interestPercentage < 0}" *matCellDef="let data">{{getAmountInPercentage(data.interestPercentage)}}</td>
  </ng-container>

  <ng-container matColumnDef="linkId">
    <th mat-header-cell *matHeaderCellDef> Koppelcode </th>
    <td mat-cell *matCellDef="let data">{{data.linkId ? data.linkId : emptyValuePlaceholder}}</td>
  </ng-container>

  <ng-container matColumnDef="linkPercentage">
    <th mat-header-cell *matHeaderCellDef> Koppel % </th>
    <td mat-cell [ngClass]="{'red': data.linkPercentage < 0}" *matCellDef="let data">{{getAmountInPercentage(data.linkPercentage)}}</td>
  </ng-container>

  <ng-container matColumnDef="storePercentage">
    <th mat-header-cell *matHeaderCellDef> Opslag % </th>
    <td mat-cell [ngClass]="{'red': data.storePercentage < 0}" *matCellDef="let data">{{getAmountInPercentage(data.storePercentage)}}</td>
  </ng-container>

  <ng-container matColumnDef="minimumPercentage">
    <th mat-header-cell *matHeaderCellDef> Minimum % </th>
    <td mat-cell [ngClass]="{'red': data.minimumPercentage < 0}" *matCellDef="let data">{{getAmountInPercentage(data.minimumPercentage)}}</td>
  </ng-container>

  <ng-container matColumnDef="maximumPercentage">
    <th mat-header-cell *matHeaderCellDef> Maximum % </th>
    <td mat-cell [ngClass]="{'red': data.maximumPercentage < 0}" *matCellDef="let data">{{getAmountInPercentage(data.maximumPercentage)}}</td>
  </ng-container>

  <ng-container matColumnDef="startDate">
    <th mat-header-cell *matHeaderCellDef> Begindatum </th>
    <td mat-cell *matCellDef="let data">{{data.startDate ? data.startDate : emptyValuePlaceholder}}</td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: tableColumns;"></tr>
</table>
<ng-template #errorTextField>
  <div class="error-text">
    {{errorText}}
  </div>
</ng-template>
